export enum MainPageType {
  Categories = 'CATEGORIES',
  Posts = 'Posts',
}
